import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import "../Signup.css"

const host = process.env.REACT_APP_BASE_URL;
export default function LogIn(props) {
    const navigate = useNavigate();
    const [credentials, setcredentials] = useState({ email: "", password: "" });
    const handlesubmit = async (e) => {
        props.setprogress(50)
        e.preventDefault();
        const response = await fetch(`${host}/api/auth/login`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email: credentials.email, password: credentials.password })
        });
        const json = await response.json();
        console.log(json);
        if (json.success) {
            localStorage.setItem('token', json.auth_token)
            navigate('/');
            props.setprogress(100)
        }
        else {
            alert("Invalid Details");
        }
    }
    const onChange = (e) => {
        setcredentials({ ...credentials, [e.target.name]: e.target.value })
    }
    return (
        <div className="login-page">
            <div className="form">
                <div className="login">
                    <div className="login-header">
                        <h3>LOGIN</h3>
                        <p>Please enter your credentials to login.</p>
                    </div>
                </div>
                <form className="login-form">
                    <input type="email" value={credentials.email} id="email" name="email" onChange={onChange} placeholder="Email" required />
                    <input type="password" value={credentials.password} name="password" required id="password" onChange={onChange} placeholder="Password" />
                    <button type="submit" onClick={handlesubmit} className="btn bt-lg bg-dark text-light rounded-pill my-2">Sign In</button>
                    <p className="message">Not registered? <Link to="/signup">Create an account</Link></p>
                </form>
            </div>
        </div>
    );
}
